import React, { useState } from "react";
import {
  Card,
  Form,
  Input,
  InputNumber,
  Button,
  Row,
  Col,
  Select,
  Space,
  Divider,
  Radio,
  message,
  notification,
} from "antd";
import {
  CopyOutlined,
  MinusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { interviewDemoSchedule } from "../../api";
import Loader from "../Loader";

function InteviewScheduleForm() {
  const [weightageError, setWeightageError] = useState("");
  const [weightage, setWeightage] = useState(0);
  const [interviewDemoData, setInterviewDemoData] = useState(null);
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(false);

  const currentDate = new Date();

  // Add 7 days to the current date
  currentDate.setDate(currentDate.getDate() + 7);

  // Convert to the desired ISO format
  const newDate = currentDate.toISOString();

  const handleCopy = () => {
    navigator.clipboard
      .writeText(interviewDemoData?.interviewUrl)
      .then(() => {
        setCopied(true);
        message.success("Link copied to clipboard!");

        // Reset copied state after 3 seconds
        setTimeout(() => {
          setCopied(false);
        }, 3000); // 3000ms = 3 seconds
      })
      .catch(() => {
        message.error("Failed to copy link.");
      });
  };

  const [form] = Form.useForm();

  const onValuesChange = (_, values) => {
    const totalWeightage =
      values.skills?.reduce(
        (sum, skill) => sum + (skill?.skillWeightage || 0),
        0
      ) || 0;

    if (totalWeightage > 100) {
      setWeightageError("Total skill weightage cannot exceed 100%.");
      setWeightage(totalWeightage);
    } else {
      setWeightage(totalWeightage);
      setWeightageError("");
    }
  };

  const onFinish = async (values) => {
    const totalWeightage = values.skills.reduce(
      (sum, skill) => sum + (skill.skillWeightage || 0),
      0
    );
    if (totalWeightage !== 100) {
      return alert("Total skill weightage must equal 100%.");
    }

    let reqBody = {
      interviewType: "AI_TWO_WAY",
      timeZone: "string",
      interviewValidityDate: newDate,
      userRole: "CANDIDATE",
      companyName: values.companyName,
      emailId: values.candidateEmailid,
      jobTitle: values.jobTitle,
      jdIdentifier: "DEMO_JD_ID",
      clientIdentifier: "DEMO_CLIENT_ID",
      candidateIdentifier: "DEMO_CANDIDATE_ID",
      candidateName: values.candidateName,
      interviewTimer: 1200,
      interviewSkillsData: values.skills,
      domain: values.domain,
      functionalArea: values.functionArea,
      configuration: {
        snapshotUploadInterval: 60,
        screenshotUploadInterval: 60,
        candidateVideoUploadInterval: 60,
        screenVideoUploadInterval: 60,
        chatHistoryUpdateInterval: 60,
        totalFraudulentChances: 3,
        whiteLabelingLink: "",
        interviewType: "AI_TWO_WAY",
        whiteLabelingRequired: false,
        transcriptionRequired: true,
        screenRecordingRequired: true,
        videoRecordingRequired: true,
        headPoseDetectionRequired: true,
        gazeDetectionRequired: true,
        candidateEmailRequired: values.sendMailToCandidate == 1 ? true : false,
        emotionAnalysisRequired: true,
      },
      userLanguage: values.language.label,
      botLanguage: values.language.label,
      userLanguageCode: values.language.value,
      botLanguageCode: values.language.value,
      yearsOfExperience: values.yearOfExperience,
      promptTemplate: "",
      evaluationPromptTemplate: "",
      speechSynthesisProvider: "Azure",
      transcriptionProvider: "deepgram",
      llmApiProvider: "azure_openai",
      llmModel: "gpt-5.4-mini",
      interviewIntroductionPrompt: "",
      interviewTimerPrompt: "",
      emailConfiguration: {
        emailTemplateId: "",
        emailBodyAdditionalData: {
          additionalProp1: "",
          additionalProp2: "",
          additionalProp3: "",
        },
      },
    };
    // console.log(values)
    // interviewDemoSchedule
    setLoading(true);
    try {
      const response = await fetch(
        interviewDemoSchedule + "?passcode=" + values.passcode,
        {
          method: "POST", // Specify the request method
          headers: {
            "Content-Type": "application/json", // Tell the server you're sending JSON
          },
          body: JSON.stringify(reqBody), // Convert your data object to a JSON string
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json(); // Parse the JSON response
      // console.log(result); // Handle the response from the server
      if (result.resultStatusInfo.resultCode === "SUCCESS") {
        setInterviewDemoData(result.data);
      } else {
        notification.error({
          description: `Unauthorize`,
          // icon: <Icon type="green-tick" />,
          placement: "topRight",
          showProgress: true,
        });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error occurred while sending the request:", error);
    }
    // console.log("Form Values:", reqBody);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      {loading && <Loader />}
      <Card
        //   title="Interview Schedule Form"
        className="sm:w-[800px] w-full"
        style={{ margin: "20px auto" }}
      >
        {interviewDemoData ? (
          // <div>{interviewDemoData?.interviewUrl}</div>
          <div className="  break-all">
            <div className="font-semibold text-xl">
              InterviewId: <span>{interviewDemoData?.interviewId}</span>
            </div>
            {/* <p className="font-semibold text-xl">Interview Url</p> */}
            <div
              style={{ userSelect: "text" }}
              className="bg-gray-200 p-2 rounded-lg"
            >
              {interviewDemoData?.interviewUrl}
              {"  "}
            </div>
            <div className="flex justify-end items-center mt-1">
              {copied ? (
                <span className="text-green-500">Copied!</span>
              ) : (
                <CopyOutlined
                  onClick={handleCopy}
                  className="cursor-pointer text-blue-500"
                  title="Click to copy"
                />
              )}
            </div>
          </div>
        ) : (
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            onValuesChange={onValuesChange}
            initialValues={{
              companyName: "",
              emailId: "",
              jobTitle: "",
              jdIdentifier: "",
              clientIdentifier: "",
              candidateName: "",
              candidatePasscode: "",
              interviewTimer: 0,
              yearOfExperience: 0,
              functionArea: "",
              domain: "",
            }}
          >
            <div className="font-semibold text-2xl mb-2">JD Details</div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-x-4 gap-y-3">
              {/* Job Title */}
              <Form.Item
                label="Job Title"
                name="jobTitle"
                className="col-span-1 m-0 p-0 "
                rules={[{ required: true, message: "Please enter job title!" }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Company Name"
                name="companyName"
                className="col-span-1 m-0 p-0 "
                rules={[
                  { required: true, message: "Please enter company name!" },
                ]}
              >
                <Input />
              </Form.Item>

              {/* Year of Experience */}
              <Form.Item
                label="Year of Experience"
                name="yearOfExperience"
                className="col-span-1 m-0 p-0 "
                rules={[
                  {
                    required: true,
                    message: "Please enter years of experience!",
                  },
                ]}
              >
                <InputNumber min={0} max={50} className="w-full" />
              </Form.Item>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-3 mt-3">
              {/* Function Area */}
              <Form.Item
                label="Function Area"
                name="functionArea"
                className="col-span-1 p-0 m-0"
                rules={[
                  { required: true, message: "Please enter function area!" },
                ]}
              >
                <Input />
              </Form.Item>

              {/* Domain */}
              <Form.Item
                label="Domain"
                name="domain"
                className="col-span-1 p-0 m-0"
                rules={[{ required: true, message: "Please enter domain!" }]}
              >
                <Input />
              </Form.Item>
            </div>
            <div className="mt-3">
              <div className="flex items-center justify-between">
                <div className="font-semibold text-lg mb-2">
                  Skill Weightage - {100 - weightage < 0 ? 0 : 100 - weightage}%
                  (remaining)
                </div>
              </div>
              <Form.List name="skills">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(
                      ({ key, name, fieldKey, ...restField }, index) => (
                        <Space key={key} className="items-start w-full">
                          <MinusCircleOutlined
                            onClick={() => remove(name)}
                            className="text-red-500 cursor-pointer "
                          />
                          <Space
                            className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2 w-full items-center"
                            align="baseline"
                          >
                            <Form.Item
                              {...restField}
                              label={index === 0 ? "Skill Name" : ""}
                              name={[name, "skillName"]}
                              fieldKey={[fieldKey, "skillName"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter skill name!",
                                },
                              ]}
                            >
                              <Input />
                            </Form.Item>
                            <Form.Item
                              {...restField}
                              label={index === 0 ? "Skill Weightage (%)" : ""}
                              name={[name, "skillWeightage"]}
                              fieldKey={[fieldKey, "skillWeightage"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter weightage!",
                                },
                              ]}
                            >
                              <InputNumber
                                min={0}
                                max={100}
                                className="w-full"
                              />
                            </Form.Item>
                          </Space>
                        </Space>
                      )
                    )}
                    <div>
                      {weightageError && (
                        <span className="text-red-500">{weightageError}</span>
                      )}
                    </div>
                    <Form.Item>
                      <Button
                        variant="dashed"
                        color="primary"
                        onClick={() => {
                          const currentSkills =
                            form.getFieldValue("skills") || [];
                          const hasIncompleteSkill = currentSkills.some(
                            (skill) =>
                              !skill?.skillName || !skill?.skillWeightage
                          );

                          if (!hasIncompleteSkill && weightage < 100) {
                            add();
                          }
                        }}
                        icon={<PlusOutlined />}
                        block
                      >
                        Add Skill
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </div>
            <Divider className="p-0 my-4 m-0" />
            <div className="font-semibold text-2xl mb-2">Candidate Details</div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-x-4 gap-y-3">
              {/* Job Title */}
              <Form.Item
                label="Name"
                name="candidateName"
                className="col-span-1 p-0 m-0"
                rules={[
                  { required: true, message: "Please enter candidate name!" },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Email-ID"
                name="candidateEmailid"
                className="col-span-1 p-0 m-0"
                rules={[{ required: true, message: "Please enter Email !" }]}
              >
                <Input />
              </Form.Item>

              {/* Year of Experience */}
              <Form.Item
                label="Send mail to candidate"
                name="sendMailToCandidate"
                className="col-span-1 m-0 p-0"
                rules={[
                  {
                    required: true,
                    message: "Please choose one of the options!",
                  },
                ]}
                initialValue={0} // Default value is "No" (0)
              >
                <Radio.Group>
                  <Radio value={1}>Yes</Radio>
                  <Radio value={0}>No</Radio>
                </Radio.Group>
              </Form.Item>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-x-4 gap-y-3 mt-3">
              <Form.Item
                label="Language"
                name="language"
                className="col-span-1 p-0 m-0"
                rules={[
                  { required: true, message: "Please select a language!" },
                ]}
                initialValue={{ value: "en-IN", label: "English (en-IN)" }} // Default value
              >
                <Select labelInValue>
                  <Select.Option value="en-IN" label="English">
                    English (en-IN)
                  </Select.Option>
                  <Select.Option value="en" label="English">
                    English (en)
                  </Select.Option>
                  <Select.Option value="en-US" label="English">
                    English (en-US)
                  </Select.Option>
                  <Select.Option value="en-AU" label="English">
                    English (en-AU)
                  </Select.Option>
                  <Select.Option value="en-GB" label="English">
                    English (en-GB)
                  </Select.Option>
                  <Select.Option value="en-NZ" label="English">
                    English (en-NZ)
                  </Select.Option>

                  <Select.Option value="hi" label="Hindi">
                    Hindi
                  </Select.Option>
                  <Select.Option value="es" label="Spanish">
                    Spanish
                  </Select.Option>
                  <Select.Option value="de" label="German">
                    German
                  </Select.Option>
                  <Select.Option value="fr" label="French">
                    French
                  </Select.Option>
                  <Select.Option value="fr-CA" label="French">
                    French (fr-CA)
                  </Select.Option>
                  <Select.Option value="it" label="Italian">
                    Italian
                  </Select.Option>
                  <Select.Option value="sv" label="Swedish">
                    Swedish (sv)
                  </Select.Option>
                  <Select.Option value="sv-SE" label="Swedish">
                    Swedish (sv-SE)
                  </Select.Option>
                  <Select.Option value="pl" label="Polish">
                    Polish
                  </Select.Option>
                  <Select.Option value="el" label="Greek">
                    Greek
                  </Select.Option>
                  <Select.Option value="uk" label="Ukrainian">
                    Ukrainian
                  </Select.Option>
                  <Select.Option value="no" label="Norwegian">
                    Norwegian
                  </Select.Option>
                  <Select.Option value="nl" label="Dutch">
                    Dutch
                  </Select.Option>
                  <Select.Option value="hu" label="Hungarian">
                    Hungarian
                  </Select.Option>
                  <Select.Option value="lv" label="Latvian">
                    Latvian
                  </Select.Option>
                  <Select.Option value="lt" label="Lithuanian">
                    Lithuanian
                  </Select.Option>
                </Select>
              </Form.Item>
            </div>
            <Divider className="mb-4 mt-5 p-0 m-0" />
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-x-4 gap-y-0">
              <Form.Item
                label="Admin password"
                name="passcode"
                className="col-span-1 p-0 m-0"
                rules={[
                  { required: true, message: "Please enter the passcode!" },
                ]}
              >
                <Input.Password />
              </Form.Item>
            </div>
            <Divider className="p-0 m-0 mt-2" />
            <div className="flex justify-end mt-4">
              <Form.Item className="p-0 m-0">
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  className="w-[200px]"
                >
                  Schedule Interview
                </Button>
              </Form.Item>
            </div>
          </Form>
        )}
      </Card>
    </>
  );
}

export default InteviewScheduleForm;
